import * as t from "io-ts";
import { createCargoDocumentTypes } from "dora-contracts";

const { cargoDocumentT } = createCargoDocumentTypes({ dateTime: t.string });

export const documentT = cargoDocumentT;
export const documentsT = t.array(documentT);

export type Document = t.TypeOf<typeof documentT>;
